// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge_Badge__1dYMt","theme-light":"Badge_theme-light__pXQPZ","Verified":"Badge_Verified__3ytpQ","theme-dark":"Badge_theme-dark__1xXDV"};